<template>
    <customModal :containermd="true" :bodysm="true" @closeModal="closeFormModal()">
         <template #title>
            {{ $t("navigations.forms") }}
        </template>
         <template #body>
            <template v-if="showLoader == true">
                <div class="text-center">
                <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                />
                <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                </div>
                </div>
            </template>
            <div v-else class="row align-items-end">
                <div v-if="formsCount == 0" class="text-center py-3">
                    {{ $t("navigations.no forms found") }}
                </div>
                <div v-else class="col-lg-12 mt-3">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th> {{ $t("navigations.eCRF") }}</th>
                                <th> {{ $t("navigations.status") }}</th>
                                <th class="text-center"> {{ $t("navigations.view") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="forms in formlist" :key="forms.sheduleId">
                                 <td>{{ forms.templateName }}</td>
                                 <td>
                                    <span
                                        class="badge"
                                        :style="{
                                        backgroundColor: forms.formStatusHex || defaultBadgeColor,
                                        color: 'black'
                                        }"
                                    >
                                        {{ forms.formStatus }}
                                    </span>
                                </td>
                                <td class="text-center" >
                                    <i
                                        v-if="forms.formStatus == 'Completed'"
                                        class="fa fa-eye edit-delete"
                                        @click.prevent="viewForm(forms.formId, forms.formStatus)"
                                    ></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
         </template>
    </customModal>
    <showformmodel
        v-if="showViewFormModal"
          :formid="selectedFormId"
          :currentformstatus="selectedFormStatus"
          @closeformModal="closeViewFormModal()"
    />
</template>

<script src="./SubActivityForms.js"></script>

<style scoped>
.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
</style>